import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SignupPage.css';

const SignupPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="signup-page">
      {/* Background Image */}
      <div className="background-image"></div>

      {/* Brand Images */}
      <div className="brand-images">
        <img src="/images/burger.png" alt="Burger" className="brand-image" />
        <img src="/images/joe.png" alt="Joe & The Juice" className="brand-image" />
        <img src="/images/7-11.png" alt="7-11" className="brand-image" />
        <img src="/images/wolt.png" alt="Wolt" className="brand-image" />
      </div>

      {/* Logo */}
      <img src="/images/logo.png" alt="Wiin Logo" className="w-logo" />

      {/* Welcome Text */}
      <h1 className="welcome-text">Velkommen til Wiin!</h1>
      <p className="subheading">Nye præmier hver dag</p>

      {/* Primary Button */}
      <button className="primary-button" onClick={() => navigate('/create-profile')}>
        <span>Opret profil</span>
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.67 9.07L23.67 13.35L18.67 17.63"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.09 13.35H23.67"
            stroke="#FFFFFF"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Social Login Buttons */}
      <div className="social-login">
        <button className="social-button facebook-button">
          <img src="/images/facebook.png" alt="Facebook" width="24" height="24" />
          <span>Fortsæt med Facebook</span>
        </button>
        <button className="social-button google-button">
          <img src="/images/google.png" alt="Google" width="24" height="24" />
          <span>Fortsæt med Google</span>
        </button>
        <button className="social-button apple-button">
          <img src="/images/apple.png" alt="Apple" width="24" height="24" />
          <span>Fortsæt med Apple</span>
        </button>
      </div>

      {/* Footer Text */}
      <p className="footer-text">
        Har du allerede en <span className="highlight-text" onClick={() => navigate('/login')}>profil</span>?
      </p>
    </div>
  );
};

export default SignupPage; 